import styled, { Scale } from '@secretescapes/falcon';

export const DetailedItem = styled('li')`
  &::marker {
    content: '•';
    font-size: ${Scale.m};
  }
`;

export const Item = styled('li')`
  display: flex;
  gap: ${Scale.xs};
  flex-direction: row;
  align-items: center;
`;

export const FacilityWrapper = styled('div')`
  margin: 0 0 0 ${Scale.xs};
  display: flex;
  gap: ${Scale.xs};
  align-items: center;
  flex-wrap: wrap;
`;
